var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionLogoWikidata({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.04 16.334h.717V4H2.04v12.334Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.523 16.334h2.203V4H3.523v12.334Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.444 4v12.333h2.202V4H6.444Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.759 16.335h.718V4h-.718v12.335Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.243 4v12.335h.718V4h-.718Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.388 16.335h.718V4h-.718v12.335Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.873 4v12.334h.718V4h-.718Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.535 16.335h-2.202V4h2.202v12.335Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.019 16.335h-.766V4h.766v12.335Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M16.737 16.334V4h2.203v12.334h-2.203Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M20.867 17.692 22 20.25h-.683l-.21-.505h-1.143l-.19.505h-.675l1.03-2.558h.738Zm.051 1.606-.411-.994-.375.994h.786Zm-1.484-1.606v.469h-.925v2.089h-.636v-2.09h-.925v-.468h2.486Zm-3.29 0 1.133 2.558h-.683l-.21-.505H15.24l-.19.505h-.674l1.029-2.558h.738Zm.051 1.606-.41-.994-.376.994h.786Zm-4.348-1.606h1.126c.435 0 .779.12 1.031.359.254.238.38.546.38.925 0 .396-.128.708-.386.935-.255.226-.62.339-1.096.339h-1.055v-2.558Zm.636.469v1.62h.415c.27 0 .476-.074.618-.221.143-.15.214-.345.214-.588 0-.252-.073-.45-.218-.593-.143-.146-.35-.218-.621-.218h-.408Zm-1.224-.469v2.558h-.636v-2.558h.636Zm-1.204 0-.832 1.201 1.127 1.357h-.796l-1.011-1.2v1.2h-.636v-2.558h.636v1.152l.811-1.152h.7Zm-2.737 0v2.558h-.636v-2.558h.636Zm-3.132.923-.79 1.668h-.274L2 17.693h.674l.602 1.413.656-1.414h.512l.656 1.414.597-1.414h.675l-1.119 2.59H4.98l-.793-1.667Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionLogoWikidata);
export default __webpack_public_path__ + "static/media/ic_action_logo_wikidata.1614ce56aa8187ca1ce54f8617ad2d99.svg";
export { ForwardRef as ReactComponent };